import { useQuery } from "@tanstack/react-query";
import useWidgetStore from "../../store/useWidgetStore";
import ConfigHolder from "../../config/ConfigHolder";
import { prepareUrl } from "../../context/WidgetContext";
import { useSettings } from "../../context/SettingsContext";
export const useResources = (options) => {
    const { enabled, selectedApptype } = useWidgetStore();
    const { api_key, widget_id } = useSettings();
    const defaultOptions = Object.assign(Object.assign({}, options), { enabled: enabled.resource, networkMode: "always", cacheTime: 0, staleTime: 0 });
    return useQuery(Object.assign(Object.assign({}, defaultOptions), { queryKey: ['widget-resource', selectedApptype], queryFn: async ({ signal }) => {
            let url = new URL(`/consumer/booking/api/method/getResources`, ConfigHolder.apiBaseUrl);
            url = prepareUrl(url, 'getResources', api_key, widget_id, {
                filter_apptype: '',
                filter_resource: '',
                apptype: selectedApptype && selectedApptype[0] !== undefined ? selectedApptype === null || selectedApptype === void 0 ? void 0 : selectedApptype.join(',') : '',
                showSelectedResource: "0"
            });
            const response = await fetch(url.href, {
                signal: signal,
                headers: {
                    'accept': 'application/ld+json',
                }
            });
            return response.json();
        } }));
};
